import { graphql } from 'src/gql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query positionWorkSettings ($sort: SortFindManyPositionWorkSettingInput) {
    lookups {
      PositionWorkSetting{
        many(sort: $sort) {
          _id
          name
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type PositionWorkSettings = NonNullable<NonNullable<NonNullable<NonNullable<TData>['lookups']>['PositionWorkSetting']>['many']>

const usePositionWorkSettings = (): PositionWorkSettings => {
  const { data } = useGraphQL(document)
  const settings = data?.lookups?.PositionWorkSetting?.many
  return settings ?? []
}

export { usePositionWorkSettings, document as positionWorkSettingDocument }
